import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BrandLogo } from '../components/BrandLogo';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { ensureSessionFromStoredAccount } from '../lib/session';
import { t } from '../lib/i18n';

export function HomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    const account = ensureSessionFromStoredAccount();
    const accessToken = localStorage.getItem('accessToken');
    const userId = localStorage.getItem('userId');
    const identitySkRaw = localStorage.getItem('identitySkRaw');
    // Only redirect if we have BOTH an accessToken and a userId
    if ((account || accessToken) && userId) {
      navigate(identitySkRaw ? '/circles' : '/unlock', { replace: true });
    }
  }, [navigate]);

  return (
    <main className="relative flex min-h-screen items-center justify-center overflow-hidden px-4 py-10">
      <div className="pointer-events-none absolute -top-24 left-1/2 h-64 w-64 -translate-x-1/2 rounded-full bg-black/10 blur-3xl dark:bg-white/10" />

      <Card className="w-full max-w-xl border-border/80 backdrop-blur-sm">
        <CardHeader className="space-y-3 text-center">
          <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground">{t('招待制 E2EE ソーシャル', 'Invite-Only E2EE Social')}</p>
          <CardTitle className="flex items-center justify-center">
            <BrandLogo
              className="inline-flex items-center gap-3 text-foreground"
              textClassName="font-mono text-4xl font-semibold leading-none md:text-5xl"
            />
          </CardTitle>
          <CardDescription className="mx-auto max-w-md text-sm md:text-base">
            {t(
              'End-to-End暗号化で会話の平穏を守る、クローズドソーシャルネットワーク。',
              'A closed social network that protects calm conversations with end-to-end encryption.'
            )}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <Button asChild className="w-full">
            <Link to="/login">{t('ログイン', 'Login')}</Link>
          </Button>
          <Button asChild variant="outline" className="w-full">
            <Link to="/register">{t('新規登録', 'Register')}</Link>
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
